import { operatorDefinitionsList } from '../operatorDefinitionsList';
// Get an operatorDefinition object by its HQL operator
export const getOperatorDefinitionByOperator = (operator: unknown): unknown => {
  return (
    operatorDefinitionsList.find((opDef) => opDef.operator === operator) || null
  );
};
